<!--
 * @FileDescription: 文件上传一个通用的模板（注释描述）
 * @Author:xy（作者）
 * @Date: 2020-07-02（时间）
 * @LastEditors: xy（最后更新人）
 * @LastEditTime: 2020-04-15（最后更新时间）
 -->
<template>
  <div class="upload">
      <input type="file"
             ref="thumbnail"
             id="input"
             :multiple="multiple"
             :style="{'width':width +'px','height':height + 'px'}"
             @change="doUpload" />
  </div>
</template>
<script>
    import {uploadMultiFile,uploadFile} from "@/utils/api";
    //放大预览
export default {
  data () {
    return {
    }
  },
  props: {
    multiple: {
      type: Boolean,
      twoWay: false
    },
    width:{
        type:Number,
        default:120
    },
    height:{
        type:Number,
        default:36
    },

  },
  watch(){

  },
  methods: {
    doUpload () {
        if(this.multiple){
            let fileUrl = []
            let index = ''
            let imageFile = this.$refs.thumbnail.files
            var form = new FormData()
            if (imageFile.length > 0) {
                for(let i = 0;i<imageFile.length;i++){
                    if(imageFile[i].size > 1024*1024 ){
                        index++
                        this.$message.warn('文件过大')
                    }else{
                        form.append("file",imageFile[i])
                    }
                }
                if(index !== imageFile.length){
                    form.append("type","store")
                    uploadMultiFile(form,{
                        'Content-Type':'multipart/form-data'
                    }).then((res)=>{
                        $('#input').val('')
                        if(res.success){
                            fileUrl = res.result
                            this.$message.success(res.logMessage)
                            this.$emit('onChangeFile',fileUrl)
                        }else{
                            this.$message.warn(res.logMessage)
                            if(res.result.length > 0){
                                res.result.forEach((item)=>{
                                    if(item.success == 'true'){
                                        fileUrl.push(item)
                                    }
                                })
                            }
                            this.$emit('onChangeFile',fileUrl)
                        }
                    })
                }
            }
        }else{
            let file = ''
            let imageFile = this.$refs.thumbnail.files[0]
            if (!this.isEmpty(imageFile)) {
                if (imageFile.size >  1024 * 1024) {
                    this.$message.warn('文件大于1兆,请重试')
                    return;
                }
                var form = new FormData()
                form.append("file",imageFile,imageFile.name)
                form.append("type","store")
                uploadFile(form,{
                    'Content-Type':'multipart/form-data'
                }).then((res)=>{
                    if(res.success){
                        this.$message.success(res.logMessage)
                        file = res.result
                        this.$emit('onChangeFile',file)
                    }else{
                        this.$message.warn(res.logMessage)
                    }
                })
            }else{
                this.$message.warn('请检查文件格式')
            }
        }
    }
  }
}
</script>
<style lang="scss">
    .upload{
        input {
            position: absolute;
            left: 0;
            top: 0;
            opacity: 0;
            filter: alpha(opacity=0);
            cursor: pointer;
            width: 100%;
            height: 100%;
        }
    }

</style>
